import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "el-dropdown-link"
};
import { useStore } from 'vuex';
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/message-box/style/css';
import { ElMessageBox, ElMessage } from 'element-plus';
import router from '@/router';
export default {
  __name: 'avater',
  setup: function setup(__props) {
    var circleUrl = 'https://tse4-mm.cn.bing.net/th/id/OIP-C.JPaFw0vH2f6Qy44aUfZ4jgAAAA?w=204&h=204&c=7&r=0&o=5&dpr=1.5&pid=1.7';
    var store = useStore();

    var logout = function logout() {
      ElMessageBox.confirm('确认退出？', '退出提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(function () {
        store.dispatch('app/logout');
        ElMessage.success('退出成功');
      }).catch(function (e) {});
    };

    var toUserInfo = function toUserInfo() {
      router.push({
        name: 'user_center'
      });
    };

    return function (_ctx, _cache) {
      var _component_el_avatar = _resolveComponent("el-avatar");

      var _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      var _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      var _component_el_dropdown = _resolveComponent("el-dropdown");

      return _openBlock(), _createBlock(_component_el_dropdown, null, {
        dropdown: _withCtx(function () {
          return [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_dropdown_item, {
                onClick: toUserInfo
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("个人中心")];
                }),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                onClick: logout
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("退出")];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_avatar, {
            size: 40,
            src: circleUrl
          })])];
        }),
        _: 1
      });
    };
  }
};